export class Fonts {
	Id: number;
	Name: string;
	SignFontIndex: number;
	CharSpacing: number;
	LineSpacing: number;
	Height: number;
}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/domain-models/Fonts.ts